module.exports = __webpack_public_path__ + "static/media/Concepts.006d673f.svg";